document.addEventListener('DOMContentLoaded', function () {
    // Sélectionner toutes les sections dialog
    const dialogSections = document.querySelectorAll('.dialog');
    
    // Pour chaque section dialog
    dialogSections.forEach(section => {
        // Sélectionner les éléments uniquement dans cette section
        const questionContainers = section.querySelectorAll('.dialog__question-container');
        const inputField = section.querySelector('.dialog-ask-anything-input-ai-input');
        const submitButton = section.querySelector('.dialog-input-submit');

        // Ajouter les écouteurs d'événements pour chaque question
        questionContainers.forEach(container => {
            container.addEventListener('click', function () {
                const questionText = this.querySelector('.dialog__question').textContent.trim();
                
                // Remplir le champ de saisie avec la question
                if (inputField) {
                    inputField.value = questionText;
                    
                    // Simuler un clic sur le bouton de soumission
                    if (submitButton) {
                        setTimeout(() => {
                            submitButton.click();
                        }, 100);
                    }
                }
            });
        });
    });
});